var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowsExpandLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10046 2.10059V0.100586H0.100464L0.100464 8.10059H2.10046L2.10046 3.51477L7.87875 9.29305L9.29296 7.87884L3.51471 2.10059H8.10046Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8995 11.8995H19.8995V19.8995H11.8995V17.8995H16.4853L10.7071 12.1213L12.1213 10.7071L17.8995 16.4853V11.8995Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsExpandLeft);
export default __webpack_public_path__ + "static/media/arrowsExpandLeft.e520137174dff2fdcf5f420263592fd0.svg";
export { ForwardRef as ReactComponent };